import {Button} from '../Footer'
import {useContext} from 'react'
import Price from './components/Price'
import {OrderDataContext} from '../../context/OrderDataContext'
import {OrderItemsContext} from '../../context/OrderItemsContext'
import Api from '../../api/api'
import { ReservationContext } from '../../context/ReservationContext'
import { TranslationContext } from '../../context/TranslationContext'
import { MenuContext } from '../../context/MenuContext'

function MenuFooter({setPage}) {
    const {order} = useContext(OrderDataContext)
    const { orderItems, setOrderItems } = useContext(OrderItemsContext);
    const {reservation} = useContext(ReservationContext)
    const {translations} = useContext(TranslationContext)
    const {menu} = useContext(MenuContext)

    if (order.location === 'to the room' && Object.keys(orderItems).length === 0) {
        return <><b>{translations.please_select_at_least_one}</b><br /><Price /></>
    }

    const checkItem = (itemId, item) => {
        const children = item.children
        const quantity = item.quantity
        const menuItem = menu.find(element => element.id == itemId)
        if (!menuItem) {
            return true;
        }

        if (!menuItem.children) {
            return true;
        }

        let freeAddons = [];
        menuItem.children.forEach((child) => {
            if (child.price === 0) {
                freeAddons.push(child.id);
            }
        });

        if (freeAddons.length === 0) {
            return true;
        }

        // check if atleast one free addons is selected but no more than one
        let selectedFreeAddons = 0;

        for (const [position, selectedItems] of Object.entries(children)) {
            for (const [key, item] of Object.entries(selectedItems)) {
                if (item.price === 0 && item.quantity > 0) {
                    selectedFreeAddons++;
                }
            }
        }

        const minimumFreeAddons = item.quantity;

        if (selectedFreeAddons < minimumFreeAddons) {
            return false;
        }

        return Object.keys(children).length === selectedFreeAddons;
    }

    const goToPage = () => {
        let canContinue = true;
        for (const [key, item] of Object.entries(orderItems)) {
            if (item.quantity === 0) {
                continue;
            }

            if (!checkItem(key, item)) {
                canContinue = false;
                item.error = true;
                setOrderItems((prev) => ({
                    ...prev,
                    [key]: item,
                }));
            } else {
                item.error = false;
                setOrderItems((prev) => ({
                    ...prev,
                    [key]: item,
                }));
            }
        }

        if (canContinue) {
            console.log('goToPage', 'confirm');
        } else {
            console.log('goToPage', 'cancel');
        }

        // setPage('confirm');
        // Api.notify({
        //     text: 'Review order click',
        //     data: {
        //         reservationCode: reservation.code,
        //         time: order.time,
        //     }
        // });
    }

    return <>
        <Button onClick={goToPage}>{translations.review_order}</Button>
        <br />
        <Price />
    </>
}

export default MenuFooter;
